import React, { Component } from 'react';
import PropTypes from 'prop-types';

class OffersV4LoanAmountDialog extends Component {
    static propTypes = {
        isOpen: PropTypes.bool.isRequired,
        onClose: PropTypes.func.isRequired,
        onSubmit: PropTypes.func.isRequired,
        currentAmount: PropTypes.number.isRequired,
        minAmount: PropTypes.number.isRequired,
        maxAmount: PropTypes.number.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            inputValue: String(props.currentAmount),
        };
        this.dialogRef = React.createRef();
    }

    componentDidUpdate(prevProps) {
        if (this.props.isOpen && !prevProps.isOpen) {
            this.setState({ inputValue: String(this.props.currentAmount) });
            document.addEventListener('keydown', this.handleKeyDown);
            document.body.classList.add('bottom-sheet-open');
        }
        if (!this.props.isOpen && prevProps.isOpen) {
            document.removeEventListener('keydown', this.handleKeyDown);
            document.body.classList.remove('bottom-sheet-open');
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
        document.body.classList.remove('bottom-sheet-open');
    }

    handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            this.props.onClose();
            return;
        }
        if (e.key === 'Tab' && this.dialogRef.current) {
            const focusable = this.dialogRef.current.querySelectorAll(
                'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
            );
            if (!focusable.length) return;
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        }
    };

    roundToNearest500 = (value) => {
        return Math.round(value / 500) * 500;
    };

    clamp = (value, min, max) => {
        return Math.min(Math.max(value, min), max);
    };

    handleInputChange = (e) => {
        const raw = e.target.value.replace(/[^0-9]/g, '');
        this.setState({ inputValue: raw });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const { minAmount, maxAmount } = this.props;
        const parsed = parseInt(this.state.inputValue, 10);

        if (isNaN(parsed)) return;

        const clamped = this.clamp(parsed, minAmount, maxAmount);
        const rounded = this.roundToNearest500(clamped);
        this.props.onSubmit(rounded);
    };

    handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            this.props.onClose();
        }
    };

    render() {
        const { isOpen, onClose } = this.props;
        const { inputValue } = this.state;

        if (!isOpen) return null;

        return (
            <div className="offers-v4-dialog-overlay" onClick={this.handleOverlayClick}>
                <div className="offers-v4-dialog" role="dialog" aria-modal="true" aria-labelledby="offers-v4-dialog-title" ref={this.dialogRef}>
                    <div className="offers-v4-dialog__top-bar">
                        <h2 id="offers-v4-dialog-title" className="offers-v4-dialog__title">
                            Edit loan amount
                        </h2>
                        <button
                            className="offers-v4-dialog__close"
                            onClick={onClose}
                            aria-label="Close"
                            type="button"
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </button>
                    </div>
                    <form className="offers-v4-dialog__form" onSubmit={this.handleSubmit}>
                        <div className="offers-v4-dialog__input-group">
                            <div className="offers-v4-dialog__input-field">
                                <label className="offers-v4-dialog__label" htmlFor="offers-v4-loan-amount">
                                    Loan amount
                                </label>
                                <div className="offers-v4-dialog__input-wrapper">
                                    <span className="offers-v4-dialog__prefix">$</span>
                                    <input
                                        id="offers-v4-loan-amount"
                                        className="offers-v4-dialog__input"
                                        type="text"
                                        inputMode="numeric"
                                        value={inputValue}
                                        onChange={this.handleInputChange}
                                        autoFocus
                                    />
                                </div>
                            </div>
                            <p className="offers-v4-dialog__hint">
                                Your loan amount will be rounded to the next $500 increment.
                            </p>
                        </div>
                        <div className="offers-v4-dialog__actions">
                            <button id="offers-v4-save-amount" className="offers-v4-dialog__save" type="submit">
                                Save
                            </button>
                            <button className="offers-v4-dialog__cancel" type="button" onClick={onClose}>
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default OffersV4LoanAmountDialog;
